module.exports = __webpack_public_path__ + "static/media/womenhealth.792809dd.svg";